export default __webpack_public_path__ + "static/media/red-dancing2-background@2x.a8ee4346.jpg";